<template>
  <errorOrder></errorOrder>
</template>

<script>
import errorOrder from "@/view/order/error/index1.vue";
export default {
  name: "abnormalShipments",
  components: {
    errorOrder,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
